import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTheme } from 'irmlib/styles'

const drawerWidth = '70px'

export const PageContentArea = styled.div`
  position: relative;
  background-color: ${props => props.theme.palette.background.default};
  width: calc(100vw - ${drawerWidth});
`

/**
 * PageHandler is the parent of any route page.
 *
 * @param {object} props see PageHandler.propTypes
 * @returns {React.ReactElement} - React component
 */
const PageHandler = props => {
  const theme = useTheme()
  return (
    <PageContentArea id={'PageContentArea'} theme={theme}>
      {props.children}
    </PageContentArea>
  )
}

PageHandler.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
}

export default PageHandler
